import React, { useState } from 'react';
import { FaTimes, FaUser,FaPhone, FaEnvelope, FaPaperPlane } from 'react-icons/fa';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import axios from 'axios';
import LoadingElement from './loadingElement';
import Notification from './Notification';

const OrderForm = ({ service, onClose }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');
    const [isloading, setisloading] = useState(false);
    const [notification, setNotification] = useState(null);
  
    


    const showNotification = (message) => {
        setNotification(message);
        setTimeout(() => setNotification(null), 3000); // Automatically hide notification after 3 seconds
      };
    
    
      const handleCloseNotification = () => {
        setNotification(null);
      };
    





    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage('');
        if (!name || !email || !message) {
            setSubmitMessage('Please fill out all fields.');
            return;
          }
      
          try {
            setisloading(true);
            // Send POST request to the backend
            const response = await axios.post('https://my-first-website-production.up.railway.app/contact', 
              { name, email, message },
              { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } } // Pass JWT token if required
            );

          //  setSubmitMessage('Your order has been submitted successfully!');
            // Clear form fields
            setName('');
            setEmail('');
            setPhoneNumber('');
            setMessage('');
            setisloading(false);
            setSubmitMessage(response.data.message);
            showNotification(response.data.message)
            
          } catch (error) {
            console.error('Error submitting contact form:', error);
            setSubmitMessage('An error occurred. Please try again.');
            setisloading(false)
            showNotification("An error occurred. Please try again.")
        }finally {
            setIsSubmitting(false);
            setisloading(false)
        }

        };
                    


    return (
      <>     
        <LoadingElement display={isloading ? "block" : "hidden"} />
        {notification && (
          <Notification
            message={notification}
            onClose={handleCloseNotification}
          />
        )}
      
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
            <div className="bg-white max-w-96 dark:bg-gray-800 bg-opacity-40 dark:bg-opacity-40 backdrop-blur-md rounded-lg p-6 w-full  relative">
                <button
                    className="absolute top-4 right-4 text-gray-700 dark:text-gray-300"
                    onClick={onClose}
                >
                    <FaTimes className="text-2xl" />
                </button>
                <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100">
                 Order {service.title}
                </h2>
                <form onSubmit={handleSubmit} className="flex space-y-4 flex-col">
                    <label className="text-gray-100 flex items-center">
                        <FaUser className="mr-2 text-gray-100" />
                        Name
                    </label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full mb-64 dark:bg-opacity-40 bg-opacity-40 p-3 mt-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-200 focus:outline-none"
                        required
                    />

<label className="text-gray-100 flex items-center">
                        <FaPhone className="mr-2 text-gray-100" />
                        Phone Number
                    </label>
                    <PhoneInput
                        country={'us'}
                        value={phoneNumber}
                        onChange={phone => setPhoneNumber(phone)}
                        inputStyle={{
                            width: 'calc(100% - 42px)',
                            padding: '1.5rem',
                            borderRadius: '0.5rem',
                            border: '1px solid #ccc',
                            background: 'rgba(255, 255, 255, 0.4)',
                            color: '#000',
                            marginLeft:'42px'
                        }}
                        buttonStyle={{
                            background: 'rgba(255, 255, 255, 0.4)',
                            marginRight:"100px",
                           
                        }}
                        
                        dropdownStyle={{
                            background: 'rgba(255, 255, 255, 0.8)',
                            color:"black"
                        }}
                    />


                    <label className="text-gray-100 flex items-center">
                        <FaEnvelope className="mr-2 text-gray-100" />
                        Email
                    </label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full dark:bg-opacity-40 bg-opacity-40 p-3 mt-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-200 focus:outline-none"
                        required
                    />

                    <label className="text-gray-100 flex items-center">
                        <FaPaperPlane className="mr-2 text-gray-100" />
                        Order requirements
                    </label>
                    <textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className="w-full dark:bg-opacity-40 bg-opacity-40 p-3 mt-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-200 focus:outline-none"
                        rows="4"
                    />

                  
                    {submitMessage && (
                        <p className={`mt-4 text-center ${submitMessage.includes('error') ? 'text-red-500' : 'text-green-500'}`}>
                            {submitMessage}
                        </p>
                    )}
                    <button
                        type="submit"
                        className="flex mt-8 justify-center items-center space-x-2 p-2 bg-inherit border-white border-4 text-gray-200 rounded-lg shadow-md dark:bg-gray-700 dark:text-white hover:-translate-y-1 transition-all duration-1000"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                </form>
            </div>
        </div>
        </>
 
    );
};

export default OrderForm;
